import React, { createContext, useContext, useMemo, useState } from 'react'

const WritingModeContext = createContext({
  writingMode: false,
  setWritingMode: () => {},
})

export function WritingModeProvider({ children }) {
  const [writingMode, setWritingMode] = useState(false)
  const value = useMemo(
    () => ({ writingMode, setWritingMode }),
    [writingMode]
  )

  return (
    <WritingModeContext.Provider value={value}>
      {children}
    </WritingModeContext.Provider>
  )
}

export function useWritingMode() {
  return useContext(WritingModeContext)
}

export default WritingModeContext
